import e, { Component as t } from "react";
import o from "../../../../node_modules/classnames/index.js";
import { tip as r } from "../Tooltip/Tooltip.js";
import n from "../../../utils/DomHandler.js";
import i from "../../../utils/ObjectUtils.js";
import { FormLabel as s } from "../Label/FormLabel.js";
function l(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function p(e, t) {
  for (var o = 0; o < t.length; o++) {
    var r = t[o];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function u(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}
function a(e) {
  return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function c(e, t) {
  return (c = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var h = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && c(e, t);
  }(d, t);
  var h,
    f,
    y,
    m = (h = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        o = a(d);
      if (h) {
        var r = a(this).constructor;
        t = Reflect.construct(o, arguments, r);
      } else t = o.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : l(this);
    });
  function d() {
    var e;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, d), e = m.apply(this, arguments), u(l(e), "tooltip", void 0), u(l(e), "cachedScrollHeight", void 0), u(l(e), "element", void 0), u(l(e), "onFocus", function (t) {
      e.props.autoResize && e.resize(), e.props.onFocus && e.props.onFocus(t);
    }), u(l(e), "onBlur", function (t) {
      e.props.autoResize && e.resize(), e.props.onBlur && e.props.onBlur(t);
    }), u(l(e), "onKeyUp", function (t) {
      e.props.autoResize && e.resize(), e.props.onKeyUp && e.props.onKeyUp(t);
    }), u(l(e), "onInput", function (t) {
      e.props.autoResize && e.resize(), e.props.onChange || (t.target.value.length > 0 ? n.addClass(t.target, "inputtextarea--filled") : n.removeClass(t.target, "inputtextarea--filled")), e.props.onInput && e.props.onInput(t);
    }), e;
  }
  return f = [{
    key: "resize",
    value: function value() {
      n.isVisible(this.element) && (this.cachedScrollHeight || (this.cachedScrollHeight = this.element.scrollHeight, this.element.style.overflow = "hidden"), this.cachedScrollHeight !== this.element.scrollHeight && (this.element.style.height = "", this.element.style.height = this.element.scrollHeight + "px", parseFloat(this.element.style.height) >= parseFloat(this.element.style.maxHeight) ? (this.element.style.overflowY = "scroll", this.element.style.height = this.element.style.maxHeight) : this.element.style.overflow = "hidden", this.cachedScrollHeight = this.element.scrollHeight));
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      this.props.tooltip && this.renderTooltip(), this.props.autoResize && this.resize();
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      e.tooltip !== this.props.tooltip && (this.tooltip ? this.tooltip.updateContent(this.props.tooltip) : this.renderTooltip()), this.props.autoResize && this.resize();
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.tooltip && (this.tooltip.destroy(), this.tooltip = null);
    }
  }, {
    key: "renderTooltip",
    value: function value() {
      this.tooltip = r({
        target: this.element,
        content: this.props.tooltip,
        options: this.props.tooltipOptions
      });
    }
  }, {
    key: "render",
    value: function value() {
      var t,
        r,
        n = this,
        l = o("kaseya-ui-inputtextarea", this.props.className),
        p = o("inputtextarea__wrapper", {
          "inputtextarea--disabled": this.props.disabled,
          "inputtextarea--filled": null != this.props.value && this.props.value.toString().length > 0 || null != this.props.defaultValue && this.props.defaultValue.toString().length > 0,
          "inputtextarea--resizable": this.props.autoResize,
          "inputtextarea--error": this.props.errorMessage,
          "inputtextarea--default-width": !this.props.cols,
          "inputtextarea--default-height": !this.props.rows
        }),
        a = i.findDiffKeys(this.props, d.defaultProps);
      return e.createElement(s, {
        className: l,
        value: this.props.label,
        errorMessage: this.props.errorMessage,
        isRequired: this.props.required
      }, e.createElement("textarea", (t = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var o = null != arguments[t] ? arguments[t] : {},
            r = Object.keys(o);
          "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(o).filter(function (e) {
            return Object.getOwnPropertyDescriptor(o, e).enumerable;
          }))), r.forEach(function (t) {
            u(e, t, o[t]);
          });
        }
        return e;
      }({}, a), r = r = {
        className: p,
        ref: function ref(e) {
          return n.element = e;
        },
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyUp: this.onKeyUp,
        onInput: this.onInput
      }, Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : function (e, t) {
        var o = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          o.push.apply(o, r);
        }
        return o;
      }(Object(r)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
      }), t)));
    }
  }], p(d.prototype, f), y && p(d, y), d;
}(t);
u(h, "defaultProps", {
  autoResize: !1,
  onInput: null,
  tooltip: null,
  tooltipOptions: null,
  label: null,
  errorMessage: null
});
export { h as InputTextarea };